/**
 * Owner: Masa Bayu
 * File: SyncQueuePanel.tsx
 * Date:Time: 2026-09-16 18:53
 * Description: T8-E3 SyncQueue UI — conflicts non-silent; ≠ entitlement invent.
 */

import { useId, useState } from 'react';
import {
  conflictDemoSync,
  enqueueDemoSync,
  getDemoAdvancedStatus,
  getDemoAdvancedSync,
  resetDemoAdvancedStore,
  resolveDemoSync,
} from './demo-advanced-store';

export interface SyncQueuePanelProps {
  readonly onNavigate: (path: string) => void;
}

export function SyncQueuePanel({ onNavigate }: SyncQueuePanelProps) {
  const statusId = useId();
  const [status, setStatus] = useState(() => getDemoAdvancedStatus());
  const [item, setItem] = useState(() => getDemoAdvancedSync());

  const refresh = (next: string) => {
    setStatus(next);
    setItem(getDemoAdvancedSync());
  };

  return (
    <section className="route-panel sync-queue" aria-labelledby="sync-queue-title">
      <h2 id="sync-queue-title">Sync · queue</h2>
      <p>
        Continuity SyncQueue. Conflicts require an explicit note — silent discard is prohibited.
      </p>
      <p id={statusId} role="status" aria-live="polite" className="sync-queue__status">
        {status}
        {item !== null ? ` · state ${item.state}` : ''}
      </p>
      <div role="group" aria-label="Sync queue actions" className="sync-queue__controls">
        <button
          type="button"
          onClick={() => {
            refresh(enqueueDemoSync());
          }}
        >
          Enqueue sync
        </button>
        <button
          type="button"
          onClick={() => {
            refresh(conflictDemoSync());
          }}
        >
          Mark conflict
        </button>
        <button
          type="button"
          onClick={() => {
            refresh(resolveDemoSync());
          }}
        >
          Resolve conflict
        </button>
        <button
          type="button"
          onClick={() => {
            resetDemoAdvancedStore();
            refresh(getDemoAdvancedStatus());
          }}
        >
          Reset demo
        </button>
        <button
          type="button"
          onClick={() => {
            onNavigate('/offline');
          }}
        >
          PWA
        </button>
      </div>
      {item !== null ? (
        <ul aria-label="Sync queue facts" className="sync-queue__facts">
          <li>{`conflictSilent=${String(item.conflictSilent)}`}</li>
          <li>{`inventsEntitlement=${String(item.inventsEntitlement)}`}</li>
          <li>{`mutatesQxp=${String(item.mutatesQxp)}`}</li>
          <li>{`conflictNote=${item.conflictNote ?? 'null'}`}</li>
        </ul>
      ) : null}
    </section>
  );
}
